import { store } from "@src/state/store";
import axios from "axios";

// Create an axios instance
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "",
});

// Add a request interceptor
api.interceptors.request.use(
  config => {
    // Get the token from local storage
    const token = store.getState().user.token;

    // If the token is present, add it to the request headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

export default api;
